import Vue from 'vue'
import VueRouter from 'vue-router'
import http from '../url'
import axios from 'axios'
import store from "@/store/index";
import {ElMessage} from 'element-plus'
const httpRequest = {
    post(url:string,data:object){
        return new Promise((resolve,reject)=>{
            axios({
                    url: http.url+url,
                    method: 'post',
                    data: JSON.stringify(data),
                    timeout: 30000,
                    headers:{
                        'Content-Type':'application/json;charset=UTF-8', //配置请求头
                        'Authorization':(store.state as any).login.token
                    }
            }).then(res=>{
                let data=res.data
                if(data.code=='200'){
                    resolve(res)
                }else if(data.code=='1011008'){
                    ElMessage.error('登陆超时，请重新登陆')
                    window.location.href='/login'
                }else{
                    ElMessage.error(data.message)
                }
                // resolve(res)
            }).catch((err)=>{
                reject(err)
            })
        })
    },
    get(url:string,datas:object){
        return new Promise((resolve,reject)=>{
            axios({
                    url: http.url+url,
                    method: 'get',
                    params: datas,
                    timeout: 30000,
                    headers:{
                        'Content-Type':'application/json;charset=UTF-8', //配置请求头
                        'Authorization':(store.state as any).login.token
                    }
            }).then(res=>{
                let data=res.data
                if(data.code=='200'||data.code=='700'){
                    resolve(res)
                }else if(data.code=='1011008'){
                    ElMessage.error('登陆超时，请重新登陆')
                    store.commit('login/SET_Token','')
                    window.location.href='/login'
                }else{
                    ElMessage.error(data.message)
                }
                // resolve(res)
            }).catch((err)=>{
                reject(err)
            })
        })
    },
    postId(url:string,data:object){
        return new Promise((resolve,reject)=>{
            axios({
                    url: http.url+url,
                    method: 'post',
                    data: data,
                    timeout: 30000,
                    headers:{
                        'Content-Type':'application/json;charset=UTF-8', //配置请求头
                        'Authorization':(store.state as any).login.token
                    }
            }).then(res=>{
                let data=res.data
                if(data.code=='200'){
                    resolve(res)
                }else if(data.code=='1011008'){
                    ElMessage.error('登陆超时，请重新登陆')
                    window.location.href='/login'
                }else{
                    ElMessage.error(data.message)
                }
                // resolve(res)
            }).catch((err)=>{
                reject(err)
            })
        })
    },
    
}
export default httpRequest